import { RDAmendment } from '@cibo/core'
import { EventDetailEditorSimple } from '../EventDetail'
import { DetailEditorPropsByYear } from '../types'
import { AmendmentEventEditorSimple } from './AmendmentEvent/AmendmentEventEditorSimple'

export const AmendmentEditorSimple = ({
  fieldModels,
  year,
  name = 'amendmentEditor',
  requirement,
  filterInputs,
  traitId,
}: DetailEditorPropsByYear) => (
  <EventDetailEditorSimple<RDAmendment['input']>
    traitId={traitId}
    fieldModels={fieldModels}
    year={year}
    name={name}
    requirement={requirement}
    filterInputs={filterInputs}
    EventComponent={AmendmentEventEditorSimple}
    translationContext="amendment"
    defaultEvent={{ date: null, amendmentType: '', method: '', rate: '', units: '' }}
  />
)
